// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"75f9892f","80":"2f9f7704","393":"fdb8d256","627":"c72d005e","675":"2f9f7704","747":"e85bbdb0"}[chunkId] + ".chunk.css";
};